import { useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '@/app/container';
import { UsersRepositoryToken } from '../../di/tokens';

/** Ações sobre os platformProfiles de um usuário; invalida o detalhe no sucesso. */
export function useProfileActions(userId: string) {
  const queryClient = useQueryClient();
  const repository = container.resolve(UsersRepositoryToken);

  const invalidate = () =>
    void queryClient.invalidateQueries({ queryKey: ['users', userId] });

  const activate = useMutation({
    mutationFn: (profileId: string) => repository.activateProfile(profileId),
    onSuccess: invalidate,
  });

  const deactivate = useMutation({
    mutationFn: (profileId: string) => repository.deactivateProfile(profileId),
    onSuccess: invalidate,
  });

  return { activate, deactivate };
}
